import React from 'react';
import { Flex } from '../../../../../Flex';
import { Typography } from '../../../../../Typography';
import { formatTime } from './utils';
export var Header = function Header(_ref) {
  var _ref$currentTime = _ref.currentTime,
      currentTime = _ref$currentTime === void 0 ? 0 : _ref$currentTime,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0 : _ref$duration;
  return /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    mb: "10px"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption2",
    color: currentTime ? 'secondary.light' : 'secondary.lighter'
  }, formatTime(currentTime)), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption2",
    color: 'secondary.lighter'
  }, formatTime(duration)));
};